import type { MutatorOptions } from 'swr';

type ScopedMutate = (
  key?: string | ((key: unknown) => boolean),
  data?: unknown,
  opts?: boolean | MutatorOptions
) => Promise<unknown>;

export async function revalidateAfterCommunityBusinessListingChange(
  mutate: ScopedMutate,
  communityId: string
) {
  await Promise.all([
    mutate('/api/user'),
    mutate('/api/communities'),
    mutate(`/api/communities/${communityId}`),
    mutate((key) => {
      if (typeof key !== 'string') return false;
      return (
        key === `/api/communities/${communityId}/business` ||
        key.startsWith(`/api/communities/${communityId}/business?`) ||
        key.startsWith(`/api/communities/${communityId}/business/filters`)
      );
    }),
    mutate(`/api/communities/${communityId}/business-links`),
    mutate((key) => {
      if (typeof key !== 'string') return false;
      return key.includes('/api/user/business/') && key.includes('/community-links');
    }),
  ]);
}

export async function revalidateAfterMembershipRequestOrMembersImport(
  mutate: ScopedMutate,
  communityId: string
) {
  await Promise.all([
    mutate('/api/user'),
    mutate('/api/communities'),
    mutate(`/api/communities/${communityId}`),
    mutate(`/api/communities/${communityId}/requests`),
    mutate((key) => {
      if (typeof key !== 'string') return false;
      return key.includes(`/api/communities/${communityId}/members`);
    }),
  ]);
}
